import { CContainer } from '@coreui/react';
import React from 'react';

const BaseContainer = React.memo(({ children, ...rest }) => {
  return <CContainer {...rest}>{children}</CContainer>;
});

export default BaseContainer;
